import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { er } from "@fullcalendar/core/internal-common";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { catchError, throwError } from "rxjs";
import { User } from "src/app/interfaces/user.interface";
import { UsersService } from "src/app/service/users.service";

@Component({
    selector: 'app-login',
    templateUrl: './restore-password.component.html',
    styleUrls: ['./restore-password.component.scss'],
    providers: [MessageService]
  })
  export class RestorePasswordComponent implements OnInit {
    loadingApi: boolean = false
    email: string = '';

    constructor(private userService: UsersService, private messageService: MessageService,
      private route: ActivatedRoute, private translate: TranslateService, private router: Router){
        // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
      }

    ngOnInit(): void {
        // Obtener el parámetro 'lang' de la URL
        this.route.queryParams.subscribe(params => {
          const lang = params['lang'];
          if (lang) {
            this.translate.use(lang);
          } else {
            this.translate.use('es'); // Idioma por defecto
          }
        });
    }

    addSingle() {
        this.messageService.add({ severity: 'success', summary: this.translate.instant('RESTORES_PASS_ALERT_SUCCESS')  , detail: this.translate.instant('RESTORES_PASS_ALERT_DETAIL')  });
      }

    resetPassword() {
      this.loadingApi = true
        const email: User = {
            email: this.email
          };
          const lang = this.translate.currentLang; // Obtener el idioma actual
          this.userService.restetPassword(email, lang).pipe(
            catchError((error) => {
              this.loadingApi = false
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
              return throwError(error);
            })
          ).subscribe((result) => {
            this.loadingApi = false
            this.addSingle()
          });
      }

      navigateToLogin(lang: string): void {
        this.router.navigate(['/login'], {
          queryParamsHandling: 'merge'
        });
      }


  
  }